import { apiClient } from "../client";

export interface PortfolioCampaignsRequest {
  startDate: string;
  endDate: string;
  profileIds: string[];
  portfolioIds: string[]; // Required
  pageSize?: number;
  pageNumber?: number;
}

export interface PortfolioCampaign {
  active: string;
  campaign_name: string;
  association: string;
  status: string | null;
  portfolio_id: string | null;
  profile_id: string | null;
  targeting_type: string | null;
  bidding_strategy: string | null;
  campaign_type: string | null;
  budget_type: string | null;
  start_date: { value: string } | null;
  end_date: { value: string } | null;
  last_updated_date: { value: string } | null;
  budget: number | null;
  budget_utilization: number | null;
  tos_plc_bid_adj_percent: number | null;
  pp_plc_bid_adj_percent: number | null;
  ros_plc_bid_adj_percent: number | null;
  spend: number;
  ad_revenue: number;
  ad_orders: number;
  impressions: number;
  clicks: number;
  ad_roas: number | null;
  ctr: number | null;
  cpc: number | null;
  ad_acos: number | null;
  aov: number | null;
  spend_percentage: number;
  cr: number | null;
  cc: number;
  campaign_ids: string[];
  tags: string | null;
}

export interface PortfolioCampaignsResponse {
  success: boolean;
  data: PortfolioCampaign[];
  total_count: number;
}

export const portfolioCampaignsService = {
  fetchCampaigns: async (
    body: PortfolioCampaignsRequest
  ): Promise<PortfolioCampaignsResponse> => {
    const { data } = await apiClient.post("/portfolio/campaigns", body);
    return data;
  },
};
